import { render } from "./GhanaChapter.vue?vue&type=template&id=c1587990"
import script from "./GhanaChapter.vue?vue&type=script&lang=js"
export * from "./GhanaChapter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__